export const GET_GAME_MENU_ITEMS_COMPLETE = "GET_GAME_MENU_ITEMS_COMPLETE";
export const GET_APP_DATA = "GET_APP_DATA";
export const GET_APP_DATA_COMPLETE = "GET_APP_DATA_COMPLETE";
export const GET_GAME_ACCESS = "GET_GAME_ACCESS";
export const GET_GAME_ACCESS_COMPLETE = "GET_GAME_ACCESS_COMPLETE";
export const SET_SELECTED_SPORT = "SET_SELECTED_SPORT";
export const SET_SELECTED_DATE = "SET_SELECTED_DATE";
export const SET_EDIT_PLAY = "SET_EDIT_PLAY";
export const SET_INSERT_PLAY = "SET_INSERT_PLAY";
export const SET_INSERT_TYPE = "SET_INSERT_TYPE";
export const SET_CONFIRM_SAVE = "SET_CONFIRM_SAVE";
export const GET_CURRENT_EVENT_SYNC_COMPLETE =
	"GET_CURRENT_EVENT_SYNC_COMPLETE";
export const SUBMITTING = "SUBMITTING";
export const SUBMITTING_COMPLETE = "SUBMITTING_COMPLETE";
export const RESET_GAME_ACCESS = "RESET_GAME_ACCESS";
export const SET_ALLOW_EVENT_SETTINGS_EDITING =
	"SET_ALLOW_EVENT_SETTINGS_EDITING";
export const GET_TEAM_API_ACCESS_COMPLETE = "GET_TEAM_API_ACCESS_COMPLETE";
export const SET_CONFIRM_SETTING_SAVE = "SET_CONFIRM_SETTING_SAVE";
export const RESET_CONFIRM_SETTING_SAVE = "RESET_CONFIRM_SETTING_SAVE";
export const QUEUE_SYNC_COMPLETE = "QUEUE_SYNC_COMPLETE";
export const SYNCING = "SYNCING";
export const SYNCING_COMPLETE = "SYNCING_COMPLETE";
export const ON_ERROR = "ON_ERROR";
export const SET_DEBUG_DATA = "SET_DEBUG_DATA";
